import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { autocompleter, AUTOCOMPLETER_STATE_SLICE_KEY, } from 'SearchApp/ts/features/base-autocomplete/state/autocompleter.reducer';
import { AppendToBodyModule } from 'Angular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { IndexOfPipeModule } from 'Angular/features/pipes/index-of/index-of-pipe.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class BaseAutocompleteModule {
}
BaseAutocompleteModule.ɵfac = function BaseAutocompleteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BaseAutocompleteModule)(); };
BaseAutocompleteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BaseAutocompleteModule });
BaseAutocompleteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AppendToBodyModule,
        CommonModule,
        DisabledModule,
        TooltipModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        IndexOfPipeModule,
        StoreModule.forFeature(AUTOCOMPLETER_STATE_SLICE_KEY, autocompleter)] });
